export default "__VITE_ASSET__D7R0sKX___"